import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { MsalRedirectComponent } from "@azure/msal-angular";
import { BrowserUtils } from "@azure/msal-browser";
import { RootComponent } from "./app/root.component";
import { appConfig } from "./app.config";
import { environment } from "./environments";

// MSAL will render the full app in an iframe when doing silent token renewal.
// We don't want to log every time the renewal takes place.
if (!BrowserUtils.isInIframe()) {
  // eslint-disable-next-line no-console
  console.log(`App version: ${environment.build}`);
}

if (environment.isProductionBuild) {
  enableProdMode();
}

bootstrapApplication(RootComponent, appConfig)
  .then((appRef) => appRef.bootstrap(MsalRedirectComponent))
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
